import { Api } from '../api';
import { accounts } from '../endpoints';
import { AddAccountRequest, getAccountsResponse, GetAllTransactionsResponse, GetTransactionsResponse } from './models';

export class AccountsApi extends Api {
  static getAccounts = (signal?: AbortSignal) => this.get<getAccountsResponse[]>({ url: accounts.account(), signal: signal });

  static getTransactions = (id: string, signal?: AbortSignal) =>
    this.get<GetTransactionsResponse[]>({ url: accounts.transactions(id), signal: signal });

  static getAllTransactions = (id: string, signal?: AbortSignal) =>
    this.get<GetAllTransactionsResponse[]>({ url: accounts.allTransactions(id), signal: signal });

  static addAccount = (request: AddAccountRequest, signal?: AbortSignal) =>
    this.post<AddAccountRequest, undefined>({ url: accounts.account(), data: request, signal: signal });
}
